import { css } from '@emotion/react';
import { InputTextColors, textStyle, containerStyle } from './checkbox';
import { SetStateAction } from 'react';
import { getColor } from '../foundations';

interface RadioButtonProps {
  name: string;
  id: string;
  value: string;
  selected: string;
  label?: string;
  color?: InputTextColors;
  testId?: string;
  checked?: boolean;
  disabled?: boolean;
  onChangeHandler: React.Dispatch<SetStateAction<string>>;
  className?: string;
}

const inputStyle = css`
  background: var(--neutral-light-n-0, ${getColor('n0')});
  border: 1px solid var(--n-400, ${getColor('n400')});
  border-radius: 16px;
  box-sizing: border-box;
  flex-shrink: 0;
  width: 16px;
  height: 16px;
  margin: 4px 0 0;
  appearance: none;

  &:checked {
    background: ${getColor('n0')};
    border: 4px solid #0052cc;
  }

  &:hover,
  &:focus {
    cursor: pointer;
    background: #dfe1e6;
  }

  &:disabled {
    background: ${getColor('n20')};
    border: none;
    cursor: default;
  }

  &:disabled + label {
    cursor: default;
  }

  &:disabled:checked {
    background: ${getColor('n70')};
    border: 4px solid ${getColor('n20')};
  }
`;

export const RadioButton = (props: RadioButtonProps) => {
  const {
    name,
    id,
    value,
    label,
    selected,
    disabled,
    testId,
    onChangeHandler,
    className
  } = props;
  const textColor = disabled ? InputTextColors.Light : InputTextColors.Dark;

  return (
    <div className={className} css={containerStyle}>
      <input
        css={inputStyle}
        type="radio"
        name={name}
        id={id}
        data-testid={testId ? testId : id}
        value={value}
        checked={selected === value}
        disabled={disabled}
        onChange={(e) => onChangeHandler(e.target.value)}
      />
      {label && (
        <label css={textStyle(textColor)} htmlFor={id}>
          {label}
        </label>
      )}
    </div>
  );
};
